import script from "./SnapshotManager.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapshotManager.vue?vue&type=script&setup=true&lang=js"

import "./SnapshotManager.vue?vue&type=style&index=0&id=54966938&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54966938"]])

export default __exports__